// removed by extract-text-webpack-plugin
module.exports = {"SocialMedia":"Footer__-loca-__2g363","InfoField":"Footer__-loca-__2m0of","Footer":"Footer__-loca-__1rQIj","FooterTag":"Footer__-loca-__1nd7e"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Footer/Footer.css
// module id = 174
// module chunks = 0